/*
 * @Author: Code-HHX
 * @Date: 2022-04-19 10:32:17
 * @LastEditors: Code-HHX
 * @LastEditTime: 2022-04-19 14:43:15
 * @Description:常用工具类
 */

//验证变量是否为空
import device from "@/api/device";

export function isNullAndEmpty(obj) {
  if (obj == null || obj == "" || obj == undefined || obj.trim() == "") {
    return true;
  } else {
    return false;
  }
}

//验证邮箱格式
export function isEmail(str) {
  var reg = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
  return reg.test(str);
}

export function calcPower(voltage, r, maxPower) {
  let power = parseFloat((Math.pow(voltage, 2) / 1000000 / r).toFixed(1));
  if (power >= maxPower) {
    power = maxPower;
  } else if (power <= 0.1) {
    power = 0.1;
  }
  return power;
}

export function calcMaxPower(voltage, r) {
  let power = Math.pow(voltage, 2) / 1000000 / r;
  return power;
}

export function calcVoltage(power, R) {
  return parseInt(Math.sqrt(power * 1000000 * R));
}

export function calcVoltageCeilInt(power, R) {
  return Math.ceil(Math.sqrt(power * 1000000 * R) / 100) * 100;
}

export function calcVoltageRoundInt(power, R) {
  return Math.round(Math.sqrt(power * 1000000 * R) / 100) * 100;
}

export function calcVoltageFloorInt(power, R) {
  return Math.floor(Math.sqrt(power * 1000000 * R) / 100) * 100;
}

export function toFloat(floatString, defaultValue) {
  let floatValue = parseFloat(floatString);
  if (floatValue.toString() === "NaN") {
    floatValue = defaultValue;
  }
  return floatValue;
}

export function handleMaxPowerVoltage(item, maxVoltage, minVoltage) {
  let voltage = Math.abs(item);
  if (voltage > maxVoltage) {
    voltage = maxVoltage;
  } else if (voltage < minVoltage) {
    voltage = minVoltage;
  }
  return -voltage;
}

export function handleHexStringToUInt16(hex) {
  let hexStr = hex;
  if (hexStr.length % 2 !== 0) {
    hexStr = `0${hexStr}`;
  }

  let buffer = Buffer.alloc(2);
  buffer[0] = parseInt(hexStr.slice(0, 2), 16);
  buffer[1] = parseInt(hexStr.slice(2, 4), 16);
  const dataView = new DataView(buffer.buffer);
  return dataView.getUint16(0, true);
}

export function delay(timeout) {
  return new Promise((resolve) => setTimeout(resolve, timeout));
}

export function convertTagId(tagId) {
  if (!(navigator.userAgent.indexOf("Android") > -1 || navigator.userAgent.indexOf("Linux") > -1)) {
    let tagIdSize = tagId.length / 2;
    let tagIdList = [];
    for (let i = 0; i < tagIdSize; i++) {
      tagIdList.push(tagId.slice(i * 2, i * 2 + 2));
    }
    tagId = tagIdList.reverse().join("").toUpperCase();
  }
  return tagId;
}

export function getQueryVariable(variable) {
  var query = window.location.search.substring(1);
  var vars = query.split("&");
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split("=");
    if (pair[0] === variable) {
      return pair[1];
    }
  }
  return (false);
}


export function click_allFunction_side(e) {
  if (e.target.className !== "head-menu-show" && e.target.className !== "header-menu") {
    return true;
  }
  if (e.target.className !== "head-function-show" && e.target.className !== "header-bluetooth") {
    return true;
  }
  return false;
}


export function createLineChartLabel(second, power, showImage, showLabel = true) {
  const p = parseFloat(power.toFixed(1));
  const labelOption = {
    value: [second, p],

    label: {
      align: "center",
      show: showLabel,
      offset: showImage ? [0, 10] : [0, 0],
      formatter: showImage ? `{a|${p.toFixed(1)}W}` : `${p.toFixed(1)}W`
    }
  };

  // if (showImage) {
  labelOption.label.rich = {
    a: {
      backgroundColor: {
        image: require("../assets/icons/v2/icon_markpoint.png")
      }, height: 60, width: 70, lineHeight: 40, padding: [0, 0, 20, 0]
    }
  };
  // }
  return labelOption;
}

export function isAndroid() {
  return (navigator.userAgent.indexOf("Android") > -1 || navigator.userAgent.indexOf("Linux") > -1);
}


const deviceR = require("@/config/deviceR.json");

export function findDeviceR(deviceId, groupNumber) {
  if (groupNumber > 0) {
    return deviceR[deviceId][groupNumber];
  } else {
    return deviceR[`${deviceId}`] || 1.2;
  }
}

export function findDeviceMaxPower(deviceId) {
  return 10;
}

export function getDeviceMacAddress(device) {
  if (navigator.bluetooth2) {
    return device.id;
  } else {
    const deviceName = device.name.replace("HB", "").trim();
    let macAddressList = [];
    for (let i = 0; i < deviceName.length / 2; i++) {
      macAddressList.push(deviceName.slice(i * 2, i * 2 + 2));
    }
    return macAddressList.join(":");
  }
}

// 将 base64 编码转换为 Blob 对象
export function b64toBlob(b64Data, contentType = "", sliceSize = 512) {
  const byteCharacters = atob(b64Data);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  const blob = new Blob(byteArrays, { type: contentType });
  return blob;
}

export function checkNicoBrand(oilType, brandName) {
  if (oilType === 7 && brandName.toLowerCase() === "zofo") {
    return true;
  }
  return false;
}

export function openExternalUrl(url) {
  if (window.openCustomUrl) {
    window.openCustomUrl(url);
  } else if (window.openUrl) {
    window.openUrl(url);
  } else {
    window.open(url);
  }
}

export function getMonthEn(month) {
  const monthsAbbreviations = [
    "Jan", // 一月
    "Feb", // 二月
    "Mar", // 三月
    "Apr", // 四月
    "May", // 五月
    "Jun", // 六月
    "Jul", // 七月
    "Aug", // 八月
    "Sep", // 九月
    "Oct", // 十月
    "Nov", // 十一月
    "Dec"  // 十二月
  ];

  return monthsAbbreviations[month];
}
export function checkDeviceLegal(tagInfo, isBrandUser) {
  let result = !!(tagInfo && tagInfo.id);

  if (isBrandUser) {
    result = result || (tagInfo.oilType === THC)
  }
  return result
}
export const NICOTINE = 1
export const THC = 2